"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiLinearProgressOverrides = void 0;
var styles_1 = require("@material-ui/core/styles");
var createMuiLinearProgressOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, shape = _a.shape;
    return ({
        root: {
            height: spacing(1),
            // Half size radius is used for small elements. May add to the theme if it becomes recurring
            borderRadius: shape.borderRadius / 2,
        },
        bar: {
            borderRadius: 2,
        },
        colorPrimary: {
            backgroundColor: palette.divider,
        },
        colorSecondary: {
            backgroundColor: palette.secondary.main,
        },
        barColorSecondary: {
            backgroundColor: palette.secondary.main,
        },
        dashed: {
            animation: "none",
        },
        dashedColorSecondary: {
            backgroundImage: "radial-gradient(" + styles_1.alpha(palette.grey[400], 0.5) + " 0%, " + styles_1.alpha(palette.grey[400], 0.5) + " 16%, transparent 42%)",
        },
    });
};
exports.createMuiLinearProgressOverrides = createMuiLinearProgressOverrides;
//# sourceMappingURL=MuiLinearProgress.js.map